<div class="markdown" [class.inline-markdown]="inline">
  <span [innerHTML]="displayText | markdown | async"></span>
  @if (wordCount > maxLength) {
    <span
      (click)="toggleExpanded()"
      class="show-more-less"
    >{{ expanded ? ' show less' : ' show more' }}</span>
  }
</div>
